import React from "react";

export const Logo: React.FC<{ size?: number }> = ({ size = 40 }) => (
  <a href="/" className="flex items-center" aria-label="Go to homepage">
    <img
      src="https://chipchip.social/assets/logo-red.png"
      alt="ChipChip Logo"
      className="hover:scale-105 transition-transform duration-300"
      width={size}
      height={size}
    />
  </a>
); 